import { getQuote, QuoteReponse } from "@/shared/http"
import type { WelcomeResponse } from "@/shared/types/myspace-api-types"
import { config } from "@/shared/utils/config"
import { useQuery } from "@tanstack/react-query"
import ky from "ky"

export const myspaceAPI = ky.create({
  prefixUrl: `https://myspace.${config.API_DOMAIN}/${config.PRODUCT}`,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
})

/**
 * URL: `/welcome`
 * METHOD: `GET`
 */
export async function getWelcomeData(
  quoteId: string,
  signal?: AbortSignal
): Promise<WelcomeResponse> {
  return await myspaceAPI
    .get("welcome", {
      searchParams: { quote_id: quoteId },
      signal,
    })
    .json<WelcomeResponse>()
}

export const useGetQuote = (quoteId: string) =>
  useQuery<QuoteReponse, Error>(["quote", quoteId], () => getQuote(quoteId), {
    enabled: !!quoteId,
    retry: 3,
    retryDelay: 1000,
  })
